import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row q-col-gutter-lg"
}
const _hoisted_3 = { class: "row justify-between q-mt-sm" }
const _hoisted_4 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_5 = {
  key: 0,
  class: "q-mb-lg"
}
const _hoisted_6 = {
  key: 0,
  class: "text-h6 q-mb-md"
}
const _hoisted_7 = { class: "row q-col-gutter-lg" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle1 text-weight-medium q-mb-sm" }, " Свободных номеров по выбранным параметрам не найдено ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-body2 text-grey-8 q-mb-sm" }, " Попробуйте изменить даты заезда и выезда или состав гостей. ", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-body2 text-grey-8 q-mb-md"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-md" }, "Альтернативные даты и варианты размещения", -1)
const _hoisted_13 = { class: "row q-col-gutter-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_room_card = _resolveComponent("room-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.actualRoom.selectedRoom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.actualRoom.isSearching)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                  return _createElementVNode("div", {
                    key: n,
                    class: "col-sm-12 col-md-6 col-lg-4"
                  }, [
                    _createVNode(_component_q_card, {
                      class: "full-height",
                      style: {"height":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_skeleton, {
                          height: "200px",
                          square: ""
                        }),
                        _createVNode(_component_q_card_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_skeleton, {
                              type: "text",
                              width: "30%",
                              class: "text-h6"
                            }),
                            _createVNode(_component_q_skeleton, {
                              type: "text",
                              class: "text-subtitle1"
                            }),
                            _createVNode(_component_q_skeleton, {
                              type: "text",
                              width: "50%",
                              class: "text-subtitle1"
                            }),
                            _createVNode(_component_q_skeleton, {
                              type: "text",
                              width: "80%",
                              class: "text-subtitle1"
                            }),
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_q_skeleton, {
                                type: "text",
                                width: "30%",
                                class: "text-subtitle1"
                              }),
                              _createVNode(_component_q_skeleton, {
                                type: "QBtn",
                                width: "150px"
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                }), 64))
              ]))
            : (_ctx.actualRoom.searchError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_q_banner, {
                    class: "bg-negative text-white",
                    rounded: ""
                  }, {
                    avatar: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "error_outline",
                        color: "white"
                      })
                    ]),
                    action: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        color: "white",
                        label: "Повторить поиск",
                        onClick: _ctx.searchRooms
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Не удалось загрузить номера. Проверьте подключение к интернету и попробуйте снова. ")
                    ]),
                    _: 1
                  })
                ]))
              : (_ctx.actualRoom.searchResult)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.hasAvailableRooms)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_ctx.hasVisibleOtherRooms)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Доступные номера"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRooms, (room) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: room.id,
                                class: "col-sm-12 col-md-6 col-lg-4"
                              }, [
                                _createVNode(_component_room_card, {
                                  room: room,
                                  roomType: "available"
                                }, null, 8, ["room"])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.hasAvailableRooms)
                      ? (_openBlock(), _createBlock(_component_q_card, {
                          key: 1,
                          flat: "",
                          bordered: "",
                          class: "q-mb-lg"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_card_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_banner, {
                                  class: "bg-grey-2",
                                  rounded: ""
                                }, {
                                  avatar: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "hotel",
                                      color: "grey-8"
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_8,
                                    _hoisted_9,
                                    (_ctx.hasVisibleOtherRooms)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Ниже показаны ближайшие доступные варианты. "))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_q_btn, {
                                      color: "primary",
                                      outline: "",
                                      label: "Изменить даты",
                                      onClick: _ctx.openDateSelector
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasVisibleOtherRooms)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleOtherRooms, (room) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: room.id,
                                class: "col-sm-12 col-md-6 col-lg-4"
                              }, [
                                _createVNode(_component_room_card, {
                                  room: room,
                                  roomType: "other"
                                }, null, 8, ["room"])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}